import io, { Socket } from 'socket.io-client'
import { MultiPersonOrderingAPI, MULTI_PERSON_SERVER_URL } from '@api/index'
import socketClient from 'common/utils/socket'

/** 多人点餐模型 */
class MultiPersonOrdering {
  /** socket实例 */
  private socket: Socket
  /** 唯一的多人点餐id */
  private orderingRoomId: string = ''
  /** 唯一的节点 */
  private _selfId = Math.floor((1 + Math.random()) * 0x100000000000000).toString(36).substring(1)
  /** 门店id */
  storeId: number
  /** 桌码 */
  tableCode: number
  /** 拼单id */
  roomKey: string;

  constructor (storeId: number, tableCode: number, roomKey?: string) {
    this.storeId = storeId
    this.tableCode = tableCode
    if (roomKey) {
      this.orderingRoomId = roomKey
    } else {
      // 创建多人点餐房间id
      this.initOrderingRoomId(storeId, tableCode)
    }
    // 创建socket实例
    this.socket = socketClient.open(MULTI_PERSON_SERVER_URL, () => {
      // 点餐人初始化数据
      this.init()
    })
  }
  /** 获取多人点餐room的唯一id */
  private initOrderingRoomId (storeId: number, tableCode: number) {
    this.orderingRoomId = `${storeId}_${tableCode}`
  }
  /** 用户进入后进行初始化操作 */
  async init () {
    // 进入app先1前置连接到多人点餐房间
    this.joinRoom()
    // 拉取多人点餐数据 this.getMultiCart()
  }
  /** 用户进来加入点餐房间 */
  private async joinRoom () {
    this.socket.emit('joinRoom', { room: this.orderingRoomId })
  }
  // /** 加入点餐人 将自己加入点餐人 */
  addPerson (data: ISyncUser) {
    this.update('set', 'user', data)
  }
  /** 拉取最新的数据 */
  async getMultiCart () {
    return await MultiPersonOrderingAPI.getMultiCart({ storeId: this.storeId, tableCode: this.tableCode, roomKey: this.orderingRoomId })
  }
  // 监听事件
  on (type: TEventType, fn: (data: object) => any) {
    this.socket.on(type, (data) => {
      if (data.operation && data.operation.type) {
        if (data.operation[data.operation.type]) {
          if (data.operation[data.operation.type]._selfId === this._selfId) {
            return
          }
        }
        // 由于数据返回包裹的不一致性当前返回的emit的事件是直接暴露data
      } else if (data._selfId) {
        if (data._selfId === this._selfId) {
          return
        }
      }
      // 这是一个全量的数据集合
      fn(data)
    })
  }
  /** 出发一个自定义的事件 */
  emit (type: string, data: object) {
    (data as any)._selfId = this._selfId
    return MultiPersonOrderingAPI.emitMultiCart({
      action: 'emit',
      key: Math.floor((1 + Math.random()) * 0x100000000000).toString(36).substring(1),
      storeId: this.storeId,
      tableCode: this.tableCode,
      roomKey: this.orderingRoomId,
      data
    } as any)
  }

  // 增加/更新/删除数据
  update (action: TMultiPersonAction, type: TMultiPersonDataType, data: object, key: string = '') {
    // const dataKey = type === 'cartItem' ? (data as ISyncCartItem).fkey : type === 'user' ? (data as ISyncUser).personId : undefined
    (data as any)._selfId = this._selfId
    return MultiPersonOrderingAPI.saveMultiCart({
      action,
      type,
      key,
      storeId: this.storeId,
      tableCode: this.tableCode,
      data,
      roomKey: this.orderingRoomId
    })
  }

  // 批量更新
  batchUpdate (action: TMultiPersonAction, type: TMultiPersonDataType, data: any[]) {
    const items = data.map(item => ({
      action,
      type,
      storeId: this.storeId,
      tableCode: this.tableCode,
      data: item,
      key: item.pk,
      roomKey: this.orderingRoomId
    }))
    return MultiPersonOrderingAPI.saveMultiCartBatch(items)
  }

  // 清空餐品数据
  clearMultiCart () {
    return MultiPersonOrderingAPI.clearMultiCart({ storeId: this.storeId, tableCode: this.tableCode, roomKey: this.orderingRoomId })
  }
  // 删除多人点餐房间
  delMultiRoom () {
    return MultiPersonOrderingAPI.delMultiRoom({ storeId: this.storeId, tableCode: this.tableCode, roomKey: this.orderingRoomId })
  }

  close () {
    socketClient.close()
  }
}

export default MultiPersonOrdering
